<shared-toolbar title="Inicio" />
<mat-card class="mt-4 p-0">
  <mat-card-content class="h-full w-full">
    <div
      class="relative flex justify-content-center align-items-center h-full w-full flex-column sm:flex-column md:flex-column lg:flex-row xl:flex-row">
      @if (isLoading()) {
        <img
          src="/assets/spinners/three-dots.svg"
          alt="loading Logo"
          class="w-14rem sm:w-9 md:w-19rem lg:w-20rem xl:w-18rem" />
      }
      @if (!isLoading()) {
        <img
          class="w-14rem sm:w-9 md:w-19rem lg:w-20rem xl:w-18rem"
          [src]="(logo() && logo()[0] && logo()[0].value) || '/assets/icon.png'"
          alt="Company Logo" />
      }
      @if (this.cookieRole !== 'SYSADMIN' && this.cookieRole !== 'ACCESOS' && data?.business) {
        <div
          class="grid h-20rem pl-0 sm:pl-0 md:pl-0 lg:pl-6 xl:pl-6 p-4 sm:p-4 md:p-0 md:pl-6 lg:p-0 xl:p-0">
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">Empresa:</span> {{ data.business.name }}
            </div>
          </div>
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">Código:</span> {{ data.business.code }}
            </div>
          </div>
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">Dirección:</span>
              {{ data.business.address }}
            </div>
          </div>
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">País:</span>
              {{ data.business.country.name }}
            </div>
          </div>
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">Representante:</span>
              {{ data.business.manager }}
            </div>
          </div>
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">Contacto:</span>
              {{ data.business.managerContact }}
            </div>
          </div>
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">Licencias Contratadas:</span>
              {{ data.business.usersCount }}
            </div>
          </div>
          <div class="col-6">
            <div class="p-3 border-round-sm">
              <span class="font-bold">Licencias disponibles:</span>
              {{ data.business.usersCount - data.business.usersCreated }}
            </div>
          </div>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
